import React from 'react';

import type { TagProps } from '@vlabs/uikit';
import { Tag } from '@vlabs/uikit';
import classNames from 'classnames';

import { calcSimilarityPercent, calcTagType } from '@vlabs/shared/utils';

import './SimilarityTag.sass';

interface SimilarityTagProps extends
  Omit<TagProps, 'value'> {
  title?: string;
  value: number;
}

export function SimilarityTag({
  value,
  kind,
  title = undefined,
  className = undefined,
  ...props
}: SimilarityTagProps): React.JSX.Element {
  const $value = (title
    ? `${title} ${calcSimilarityPercent(value)}`
    : calcSimilarityPercent(value)) as string;
  return (
    <Tag
      className={classNames(className, {
        [`SimilarityTag_${calcTagType(value)}`]: !!value,
      })}
      kind={kind ?? calcTagType(value)}
      value={$value}
      {...props}
    />
  );
}
